import styled from 'styled-components'

const Paper = styled.div`
  width: 54%;
  min-width: 800px;
  background: #ffffff;
  box-shadow: 1px 1px 2px #00000080;
  border-radius: 12px;
  padding: 60px;
  margin: 100px auto 40px auto;

  @media (max-width: 830px) {
    width: 90%;
    min-width: 90%;
    padding: 20px;
    margin: 20px auto 20px auto;
  }
`

export default Paper
